import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Favorite from './Favorite';
import { get } from 'lodash';
import {
  PARTNERS,
  EXTERNAL_PARTNERS,
  BIG_COMMERCE
} from '../../../lib/constants';

class CategoryToolTile extends React.Component {
  componentDidMount() {
    const {
      fptiImpression,
      fpti = '',
      tool: {
        appKey = '',
        appFPTI = '',
        categoryKey = '',
        rank = '',
        priorityScore = '',
        sectionKey = ''
      } = {},
      toolTileProps: { flatPSData = {} } = {},
      insideSection = false,
      pageLink = ''
    } = this.props;
    const currentCategory = get(flatPSData, ['categories', categoryKey]) || {};
    const currentSection = get(flatPSData, ['sections', sectionKey]) || {};
    const currentFPTIPage = insideSection ? fpti : currentCategory.categoryFPTI;
    fptiImpression({
      prod: appFPTI,
      pageLink: pageLink || currentFPTIPage,
      categoryRank: currentCategory.rank,
      sectionRank: currentSection.rank,
      appKey,
      rank,
      priorityScore
    });
  }

  handleFavoriteClick = () => {
    const {
      toolTileProps: {
        dispatch,
        setRPSFavorites,
        toggleToolFavorite,
        tools: toolServTools
      } = {},
      tool: { appKey = '' } = {}
    } = this.props;

    const MTSTool = toolServTools[appKey];
    // if it can be favorited by toolserv do so
    if (MTSTool && MTSTool.active && typeof MTSTool.favorite === 'boolean') {
      // call MTS and set favorite there
      dispatch(toggleToolFavorite(MTSTool));
    } else {
      // if it can't be favorited by toolserv set it in RPS
      dispatch(setRPSFavorites(appKey));
    }
  };

  render() {
    const {
      tool: {
        appImage = '',
        appBody = '',
        appTitle = '',
        appKey = '',
        appFPTI = '',
        location = '',
        categoryKey = '',
        ariaLabel = '',
        PSClickUrl = '',
        rank = '',
        priorityScore = '',
        sectionKey = ''
      } = {},
      toolTileProps: {
        RPSFavorites,
        toolServFavorites,
        app,
        flatPSData = {}
      } = {},
      handleClickTool,
      path
    } = this.props;

    let imgUrl;

    // This is because not all of PS is updated yet
    try {
      imgUrl = JSON.parse(appImage);
      if (!imgUrl.alt) {
        imgUrl.alt = '';
      }
    } catch (e) {
      imgUrl = {
        icon: appImage,
        alt: ''
      };
    }

    const partnerOrMarketplace =
      EXTERNAL_PARTNERS.includes(appKey) ||
      PARTNERS.includes(appKey) ||
      appKey === BIG_COMMERCE;

    const clickToolHandler = favoriteLink => {
      const currentCategory =
        get(flatPSData, ['categories', categoryKey]) || {};
      const currentSection = get(flatPSData, ['sections', sectionKey]) || {};
      return handleClickTool({
        fptiLink: favoriteLink ? favoriteLink : appFPTI,
        prod: appFPTI,
        PSUrl: PSClickUrl,
        categoryKey,
        categoryRank: currentCategory.rank,
        sectionRank: currentSection.rank,
        appKey,
        rank,
        priorityScore
      });
    };

    return (
      <Link
        className="undo-link-styles tile-link-wrapper add-focus-visible"
        onClick={clickToolHandler()}
        to={`${path}/${location}`}
      >
        <div className="category-tool-tile">
          <div className="category-tool-tile-context">
            <div
              className={`category-tool-tile-image ${
                partnerOrMarketplace ? 'partner-marketplace' : ''
              }`}
              style={{
                background: `url(${imgUrl.icon}) center center no-repeat`,
                backgroundSize: partnerOrMarketplace ? '100%' : '80%'
              }}
            />
            <div className="category-tool-tile-title">
              <h3
                className={`${
                  appTitle.replace(/\s+/g, '').length > 16 ? 'ticker ' : ''
                }${
                  partnerOrMarketplace ? 'category-tool-tile-title-spacing' : ''
                }`}
              >
                {appTitle}
              </h3>
            </div>
            <Favorite
              tool={{
                favorite:
                  !!RPSFavorites[appKey] || toolServFavorites.includes(appKey)
              }}
              toggleFavorite={this.handleFavoriteClick}
              handleClickTool={clickToolHandler}
              isLoggedIn={get(app, 'fptiData.lgin', true)}
              ariaLabel={ariaLabel}
              title={appTitle}
            />
          </div>
          <div className="category-tool-tile-text">
            <p>{appBody}</p>
          </div>
        </div>
      </Link>
    );
  }
}

CategoryToolTile.propTypes = {
  tool: PropTypes.object,
  path: PropTypes.string,
  fpti: PropTypes.string,
  fptiImpression: PropTypes.func,
  handleClickTool: PropTypes.func,
  toolTileProps: PropTypes.object,
  insideSection: PropTypes.bool,
  pageLink: PropTypes.string
};

export default CategoryToolTile;
